import * as telemetry from '@cian/telemetry/browser';
import * as httpApi from '@cian/http-api/browser';

export function setupDependencies() {
  telemetry.setup();
  httpApi.setup({ assertStatusCode });
}

export function assertStatusCode() {
  return true;
}
